// Pre-order functionality
const fetchCart = async () => {
    try {
      const res = await fetch('/cart.js');
      const data = await res.json();
      if (res.ok) return data;
    } catch (error) {
      console.log(error);
      return null
    }
}
(function ($) {
    var $ = jQuery = $;

    function updateCart(variantId, preOrderQty) {
        let updates = {
            [variantId]: preOrderQty
        };
        
        fetch(window.Shopify.routes.root + 'cart/update.js', {
            method: 'POST',
            headers: {
            'Content-Type': 'application/json'
            },
            body: JSON.stringify({ updates })
        })
        .then(response => {
            
            
            if($('.template-cart').length == 1) {
                document.documentElement.dispatchEvent(new CustomEvent('theme:cartchanged.cartTemplateSection'));
                $('.close-box').click();
                alert(`Only ${preOrderQty} available for pre-order`);
                window.location.reload();
            } else {
                theme.updateCartSummaries(false, false, false);
                alert(`Only ${preOrderQty} available for pre-order`);
            }
            
            return response.json();
        })
        .catch((error) => {
            console.error('Error:', error);
        });
    }

    $(window).on('cc-cart-updated', async (e, args) => {
        const cart = await fetchCart();
        const cartItems = cart.items;
        const preOrderItemsCart = cartItems.filter(item => item.properties['Pre-order'] !== undefined);
        const preOrderItemsArgs = args.cartItemData.items.filter(item => item.properties.some(property => property.name === 'Pre-order'));
        if(preOrderItemsCart.length > 0) {
            preOrderItemsCart.forEach((item, index) => {
                const preOrderQty = preOrderItemsArgs[index].preorder_qty;
                const cartQty = item.quantity;
                if(preOrderQty > 0 && cartQty > preOrderQty) {
                    updateCart(item.id, preOrderQty);
                }
            });
        }
    });
})(theme.jQuery);